import { render, staticRenderFns } from "./ProfitOrLosesPercentInTable.html?vue&type=template&id=10b9bc7e&scoped=true&"
import script from "./ProfitOrLosesPercentInTable.js?vue&type=script&lang=js&"
export * from "./ProfitOrLosesPercentInTable.js?vue&type=script&lang=js&"
import style0 from "./ProfitOrLosesPercentInTable.scss?vue&type=style&index=0&id=10b9bc7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9bc7e",
  null
  
)

export default component.exports